<template>
	<v-card>
		<v-card-title><translate>Claim Status</translate></v-card-title>
		<v-card-text>
			<v-row>
				<v-col
					lg="6"
				>
					<label><translate>Current Status</translate></label>
					<v-text-field
						hide-details
						readonly
						:model-value="$gettext(claim.claimStatusName)"
						variant="outlined"
					/>
				</v-col>
				<v-col
					v-can="'claim.update'"
					lg="6"
				>
					<label><translate>New Status</translate></label>
					<v-select
						v-model="claimStatus"
						:items="claimStatuses"
						:item-title="item => $gettext(item.name)"
						item-value="id"
						return-object
						:error="claimStatusError"
						variant="outlined"
						@update:model-value="claimStatusError = false"
					/>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer />
			<v-dialog
				v-model="dialog"
				width="800"
				persistent
			>
				<template #activator="{ props }">
					<v-btn
						color="primary"
						v-bind="props"
						:disabled="!claimStatus"
						@click="getChangeStatusInfo"
					>
						<translate>Save</translate>
					</v-btn>
				</template>
				<v-card>
					<v-card-title>
						<v-row
							no-gutters
							class="d-flex align-center"
						>
							<v-col>
								<translate>{{ claim.claimStatusName }}</translate> &rarr; <translate>{{ claimStatus.name }}</translate>
							</v-col>
							<v-spacer class="flex-grow-1 flex-shrink-0" />

							<v-col class="flex-grow-0 flex-shrink-1">
								<v-btn
									variant="text"
									icon="$close"
									@click="dialog = false"
								/>
							</v-col>
						</v-row>
					</v-card-title>
					<v-card-text v-if="transitionData.hasEmailtemplatetype">
						<v-row class="d-flex align-center">
							<v-col>
								<h3>
									<v-icon
										icon="$email"
										start
									/>
									<translate>Email</translate>
									&#8220;{{ transitionData.emailtemplatetypeTitle }}&#8220;
									<translate>send</translate>
								</h3>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<em><translate>An e-mail is sent to the customer at this status transition.</translate></em>
							</v-col>
						</v-row>
						<v-row
							v-for="variable in transitionData.variables"
							:key="variable"
						>
							<v-col>
								<v-textarea
									v-model="manualVariables[(variable)]"
									variant="outlined"
									rows="3"
									auto-grow
									:label="`${$gettext('Variable')}: $${variable}`"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-btn
									color="primary"
									variant="flat"
									@click="saveStatusChange(false)"
								>
									<translate>Save and Mail</translate>
								</v-btn>
							</v-col>
							<v-col>
								<v-btn
									variant="flat"
									@click="showPreview"
								>
									<translate>Show Example</translate>
								</v-btn>
							</v-col>
							<v-col>
								<v-btn
									v-if="transitionData.canTransition"
									v-can="'claim.statustransitionwithoutmailing'"
									variant="flat"
									@click="saveStatusChange(true)"
								>
									<translate>Save without Mailing</translate>
								</v-btn>
							</v-col>
							<v-spacer />
						</v-row>
						<v-spacer />
					</v-card-text>
					<v-card-text v-else>
						<v-row>
							<v-col>
								<v-btn
									color="primary"
									variant="flat"
									@click="saveStatusChange(false)"
								>
									<translate>Save</translate>
								</v-btn>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions />
				</v-card>
			</v-dialog>
		</v-card-actions>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	displayError, inform,
} from 'laravel-front-library';
export default {
	name: 'ChangeClaimStatusCard',
	props: {
		claim: {
			type: Object,
			required: true
		},
		claimStatuses: {
			type: Array,
			required: true
		},
	},
	data () {
		return {
			claimStatus: null,
			claimStatusError: false,
			dialog: false,
			transitionData: [],
			previewParams: '',
			manualVariables: {
			}
		};
	},

	methods: {
		/**
		 * Retrieve information about the transition
		 */
		getChangeStatusInfo () {
			axios.get(`/api/v0/claims/status?id=${this.claim.id}&claimstatus_id=${this.claimStatus.id}`)
				.then(({
					data: data
				}) => {
					this.transitionData = data;
					if (data.variables.length > 0) {
						data.variables.forEach((variable) => {
							this.manualVariables[(variable)] = '';

						});
					}
				}).catch((error) => {
					displayError(this.$gettext('Something has gone wrong during data retrieval'));
					window.captureException(error);
				}).finally(() => {
					this.dialog = true;
				});
		},

		/**
		 * Save the status change
		 *
		 * @param {boolean} dontMail
		 */
		saveStatusChange (dontMail) {
			axios.put('/api/v0/claims/status', {
				'id': this.claim.id,
				'dontMail': dontMail,
				'claimstatusId': this.claimStatus.id,
				'variablesManual': this.manualVariables
			}).then(() => {
				this.dialog =
				inform(this.$gettext('Updated'));
				setTimeout(() => {
					window.location.reload();
				}, 300);
			}).catch((error) => {
				displayError(this.$gettext('Something went wrong while trying to change the status.'));
				window.captureException(error);
			});
		},

		/**
		 * Show a preview of the email
		 */
		showPreview () {
			this.previewParams = '';
			for (const variable in this.manualVariables) {
				this.previewParams += '&' + variable + '=' + this.manualVariables[variable];
			}
			this.previewParams += '&claim_id=' + this.claim.id;
			window.open(`/bo/preview?id=${this.transitionData.emailtemplateId}` + this.previewParams);
		}
	}
};
</script>
